export const RiskAnswerOptions = {
  YES: 'Yes',
  NO: 'No',
  UNANSWERED: '',
} as const;

export type RiskAnswerOptions =
  typeof RiskAnswerOptions[keyof typeof RiskAnswerOptions];
